module.exports = __webpack_public_path__ + "static/media/polls.e72047d2.svg";